<script>
import ListForm from '../ListForm.vue'
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    ListForm,
  },
  data(){
    return {
      value: null,
      listData: new Array,
      selectedItem: new Object,
      prevSelectedItem: '{}',
      showListForm: false
}
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x => x.active == true)).length;
    },
    filteredList() {
      return this.listData;
    },
  },
  watch: {
    topbarControls: {
      handler: function(val) {
        if(val.title == 'Groups') {
          console.log(val)
          if(!this.listData.length) {
            console.log(val)
            // this.setSelectedItems(new Object)
          } else {
            if(this.selectedItem && this.selectedItem.id) {
              if(val.selectedItem.id != this.selectedItem.id) {
                this.selectedItem = val.selectedItem;
              }
              if(!val.listItems.length) {
                this.listData = [];
                this.setSelectedItems(new Object)
              }
              if(!this.listData.filter(x => x.id == val.selectedItem.id).length) {
                this.setSelectedItems(this.listData[0])
              }
            } 
            else if(!Object.keys(this.selectedItem).length && val.selectedItem && Object.keys(val.selectedItem).length) {
              this.selectedItem = val.selectedItem;
            }
            if(this.listData != val.listItems) {
              this.listData = val.listItems;
            }
          }
        }
      },
      // if(val.title == 'Groups') {
      //     if(val.selectedItem != this.selectedItem) {
      //       this.selectedItem = val.selectedItem;
      //     }
      //     if(!this.listData.filter(x => x.id == val.selectedItem.id).length) {
      //       this.setSelectedItems(this.listData[0])
      //     }
      //     else if(!val.listItems.filter(x => x.id == this.listData[0].id).length) {
      //       this.setTopbarControls(null, this.listData, null, null, null)
      //     }
      //     if(this.listData != val.listItems) {
      //       this.listData = val.listItems;
      //     }
      //   }
      // },
      deep: true
    },
  },
  methods: {
    setSelectedItems(val) {
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(null, this.listData, this.selectedItem, this.prevSelectedItem, this.category)
    },
    setListItems(val, sort) {
      if(sort) this.listData = val.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
      else this.listData = val;
      if(this.listData.length) {
        this.setSelectedItems(this.listData[0])
      } else {
        this.setSelectedItems(new Object)
      }
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId)
      this.category = data;
      let groups = data.additionalProp1.groups;

      if(groups && groups.length) this.setListItems(groups, false)
      else this.setListItems([], false)
    }
  },
  async mounted() {
    await this.getData();
  }
};
</script>
<template>
  <ListForm
      :style="item.style"
      :class="`col-${item.size} ${item.class}`"
      :item="item"
      :items="item.children"
      :selectedItem="selectedItem"
      :listItems="listData"
      :prevSelectedItem="prevSelectedItem"
      :setSelectedItems="setSelectedItems"
      :topbarControls="topbarControls"
  />
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>